@if (
    !(errorService.errorGeneral$ | async) &&
    operation &&
    !isTwoFactorModalVisible &&
    !showDelayedProcessWarning &&
    (process?.config?.isDeviceAllowed || operation?.type === operationType.FINISH)
) {
    @if (operation.type === operationType.HOME) {
        <div>
            <app-home [operations]="operations" [operation]="operation" />
        </div>
    }
    @if (operation.type === operationType.OCR) {
        <div>
            <!-- NIF-802/921: flexible monta el mismo journey que auto (app-ocr) -->
            @if (operation.config.mode === MODE.AUTO || operation.config.mode === MODE.FLEXIBLE) {
                <app-ocr [operations]="operations" [operation]="operation" />
            }
            @if (operation.config.mode === MODE.MANUAL) {
                <app-manual-ocr [operations]="operations" [operation]="operation" />
            }
        </div>
    }
    @if (operation.type === operationType.OCR_CANNY) {
        <div>
            <app-ocr-canny [operations]="operations" [operation]="operation" />
        </div>
    }
    @if (operation.type === operationType.POL) {
        <div>
            @if (operation.config.mode === MODE.AUTO) {
                <app-life-check [operations]="operations" [operation]="operation" />
            }
            @if (operation.config.mode === MODE.MANUAL) {
                <app-manual-life-check [operations]="operations" [operation]="operation" />
            }
        </div>
    }
    @if (operation.type === operationType.DOCUMENTS) {
        <div>
            <app-docs [operations]="operations" [operation]="operation" />
        </div>
    }
    @if (operation.type === operationType.FORM) {
        <div>
            <app-dynamic-form [operations]="operations" [operation]="operation" />
        </div>
    }
    @if (operation.type === operationType.CHOOSE) {
        <div>
            <app-choose [operations]="operations" [operation]="operation" />
        </div>
    }
    @if (operation.type === operationType.CONNECTIONS) {
        <div>
            @switch (operation.config.type) {
                @case (connectionType.WORK_LIFE) {
                    <app-work-life [operations]="operations" [operation]="operation" />
                }
                @case (connectionType.BANK_SCORING) {
                    <app-bank-scoring [operations]="operations" [operation]="operation" />
                }
                @case (connectionType.IRPF) {
                    <app-irpf [operations]="operations" [operation]="operation" />
                }
                @case (connectionType.SCRIPTURE) {
                    <app-scripture [operations]="operations" [operation]="operation" />
                }
            }
        </div>
    }
    @if (operation.type === operationType.FINISH) {
        <div>
            <app-finish
                [operation]="operation"
                [process]="process"
                (incompleteOperations)="onFinishIncompleteOperations()"
            />
        </div>
    }
}

@if (errorService.errorGeneral$ | async) {
    <tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }">
        <ng-container content>
            <app-error [errorConfig]="errorService.errorGeneral$ | async" />
        </ng-container>
    </tec-pwcs-layout>
}

<!-- TODAS LAS OPERACIONES COMPLETADAS; sin `process` el switch caía en @default (mensaje de caducado) durante la carga inicial. -->
@if (!operation && !(errorService.errorGeneral$ | async) && process) {
    <tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }">
        <ng-container content>
            @switch (process?.status_process_device) {
                @case (processStatus.OK) {
                    <tec-tile
                        type="status"
                        [title]="'GENERAL.PROCESS.FINISH_TITLE' | translate"
                        [subtitle]="'GENERAL.PROCESS.FINISH_DESCRIPTION' | translate"
                        tagIconStatus="default"
                        icon="icon-alert"
                    />
                }
                @case (processStatus.KO) {
                    <tec-tile
                        type="status"
                        [title]="'GENERAL.PROCESS.FINISH_TITLE' | translate"
                        [subtitle]="'GENERAL.PROCESS.FINISH_DESCRIPTION' | translate"
                        tagIconStatus="default"
                        icon="icon-alert"
                    />
                }
                @case (processStatus.CANCELLED) {
                    @if (process?.primary_device) {
                        <tec-tile
                            type="status"
                            [title]="cancelledProcessTitle()"
                            [subtitle]="cancelledProcessDescription()"
                            tagIconStatus="default"
                            icon="icon-alert"
                        />
                    }
                    @if (!process?.primary_device) {
                        <tec-tile
                            type="status"
                            [title]="'FINISH.SECONDARY_DEVICE_TITLE' | translate"
                            [subtitle]="'FINISH.SECONDARY_DEVICE_DESCRIPTION_CLOSED' | translate"
                            icon="icon-capture-opened-window"
                            tagIconStatus="info"
                        >
                            <tec-qr
                                [url]="auth.getQRUrl()"
                                [copyLabel]="'GENERAL.BUTTON.COPY_LINK' | translate"
                                [text]="auth.getQRUrl()"
                            />
                        </tec-tile>
                    }
                }
                @case (processStatus.STANDBY) {
                    <tec-tile [type]="'loading'" [title]="'GENERAL.PROCESS.STANDBY_TITLE' | translate" />
                    <tec-alert [msg]="'GENERAL.PROCESS.STANDBY_ALERT' | translate" hiddenCloseButton />
                }
                @default {
                    <tec-tile
                        type="status"
                        [title]="expiredProcessTitle()"
                        [subtitle]="expiredProcessDescription()"
                        tagIconStatus="default"
                        icon="icon-alert"
                    />
                }
            }
        </ng-container>
        @if (process?.status_process_device === processStatus.STANDBY) {
            <ng-container actions>
                <tec-button size="lg" (click)="openModalConfirm()">
                    {{ 'GENERAL.BUTTON.CONTINUE_THIS_DEVICE' | translate }}
                </tec-button>
            </ng-container>
        }
    </tec-pwcs-layout>
}

<!-- ACCEPT CHANGE DEVICE -->
@if (showDelayedProcessWarning && !isTwoFactorModalVisible && !(errorService.errorGeneral$ | async)) {
    <app-delayed-process-warning
        [process]="process"
        (unSubscribeCheckStatus)="unSubscribeCheckStatus()"
        (closed)="onDelayedProcessWarningClosed()"
    />
}

<!-- DISPOSITIVO NO PERMITIDO -->
@if (!(errorService.errorGeneral$ | async) && !process?.config?.isDeviceAllowed && operation && operation?.type !== operationType.FINISH && !isTwoFactorModalVisible) {
    <tec-pwcs-layout [ngClass]="{ dark: designService.isDarkMode() }">
        <ng-container content>
            <app-device-not-allowed />
        </ng-container>
    </tec-pwcs-layout>
}

<!-- 2FA: capa a pantalla completa; `2fa` solo en la raíz (`false` | `sms` | `whatsapp`). -->
@if (isTwoFactorModalVisible && twoFactorModalTfaType; as tfa) {
    <div class="user-identification__tfa-layer" role="presentation">
        <app-two-factor-modal
            [tfaType]="tfa"
            (verified)="onTwoFactorVerified()"
            (processFinished)="onTwoFactorProcessFinished()"
        />
    </div>
}
